import React from "react";

export default function Header({ userName, onLogout }) {
  return (
    <header
      style={{
        height: 64,
        background: "#fff",
        borderBottom: "1px solid #e2e5ea",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 28px",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        {/* Replace with actual <img src={logo} /> once logo asset is added */}
        <div
          style={{
            width: 38,
            height: 38,
            borderRadius: 6,
            background: "#0b2545",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 700,
            fontSize: 14,
          }}
        >
          IOA
        </div>
        <div>
          <div style={{ fontWeight: 700, color: "#0b2545", fontSize: 16 }}>
            I-OnAsia
          </div>
          <div style={{ fontSize: 11, color: "#6b7280", letterSpacing: 0.5 }}>
            eKYC CLIENT PORTAL
          </div>
        </div>
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
        <span style={{ fontSize: 14, color: "#1c1c1c" }}>{userName || "Client User"}</span>
        <button
          onClick={onLogout}
          className="btn-primary"
          style={{ padding: "8px 16px", fontSize: 13 }}
        >
          Log out
        </button>
      </div>
    </header>
  );
}
